import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.371 2.549A1 1 0 0 0 10 3.477V6h1.5A1.5 1.5 0 0 1 13 7.5V20h-2V9a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v11H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-1V6.677a1 1 0 0 0-.629-.928zM6 20h3v-1.5a1.5 1.5 0 0 0-3 0zm12-2.5V20h-3v-2.5a1.5 1.5 0 0 1 3 0M16.316 6.439A1 1 0 0 0 15 7.387V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7.72a1 1 0 0 0-.684-.948zM7 10a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2z",
      clipRule: "evenodd"
    }
  )
);
var SvgCompanyFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CompanyFilled_default = SvgCompanyFilled;

export { CompanyFilled_default as default };
